import store from "../store";
import socketAPI from "./socketAPI";

/* ====== INITALIZE NAMESPACE SOCKET COMMUNICATES TO ====== */
const NAMESPACE = "/messages";

/* ====== SOCKET STATES ====== */
let socketNSP = null;

const messengerSocket = {
  /* ====== INITIALIZE SOCKET ====== */
  async initMessengerSocket() {
    /** Custom listeners defined here because calendarSocket not available before initialization (hoisting) */
    const CUSTOM_LISTENERS = {
      connect: messengerSocket.handleConnect,
      "MESSAGE:NEW": messengerSocket.newMessageHandler,
      "MESSAGE:READ": messengerSocket.messageReadHandler,
      "CONNECTIONS:NEW": messengerSocket.newConnectionsHandler,
    };
    socketNSP = await socketAPI.initSocketNSP(NAMESPACE, CUSTOM_LISTENERS);
  },

  /**
   * ==========================================================
   * ======================= RECEIVERS ========================
   * ==========================================================
   */

  handleConnect() {},

  /**
   * Handles received message.
   *
   * 1. checks if the message is sent by the user or to the user
   * 2. stores message in messages vuex
   * 3. updates the last message notification in vuex if was from partner
   *
   * @param {Array} message the received message
   * @param {Number} message.0 the current last batch nr
   * @param {String} message.1 the connection ID
   * @param {String} message.2 the sender ID
   * @param {String} message.3 the receiver ID
   * @param {String} message.4 the message itself
   * @param {Number} message.5 the date of message in MS
   */
  async newMessageHandler(message) {
    const currentUserID = store.getters["auth/userID"];
    if (message && message.length === 6) {
      if (message[3] !== currentUserID && message[2] !== currentUserID) {
        console.error("wth just happened");
        return;
      }
      const messageData = {
        CID: message[1],
        senderID: message[2],
        message: message[4],
        date: new Date(message[5]),
        newestBatchNr: message[0],
        currentUserID,
      };

      const partner = await store.dispatch("messages/addNewMessage", messageData);
      if (message[3] === currentUserID && partner) {
        /* if received a message and modal is not opened, set indicator dot */
        if (!store.getters["messages/getModalOpenStatus"]) {
          store.commit("indicators/ACTIVATE_INDICATOR", "messenger");
        } else {
          /* Checking document focus ensures that if there are multiple tabs open,
          and in one of the tabs the Messenger Modal is open,
          then if the user is not currently on the tab with the 
          open modal, then a message is not set as seen. */
          if (document.hasFocus()) {
            this.setMessagesAsSeen();
            /* if current convo is opened, mark messages as read */
            if (store.getters["messages/getCurrentConvoID"] === messageData.CID) {
              await this.setConvoAsRead(messageData.CID);
            }
          }
        }
      }
    } else {
      console.error("received invalid message");
    }
  },

  /**
   * Handles the case when in another tab/device the user read a message.
   * @param {String} conversationID the ID of the convo the user read
   */
  messageReadHandler(conversationID) {
    store.commit("messages/SET_CONVERSATION_AS_READ", conversationID);
  },

  newConnectionsHandler() {
    store.commit("indicators/ACTIVATE_INDICATOR", "connectRequests");
  },

  /**
   * ==========================================================
   * ======================== EMITTERS ========================
   * ==========================================================
   */

  /**
   * @param {Array} message the message to send
   * @param {Number} message.0 the current last batch nr
   * @param {String} message.1 the connection ID
   * @param {String} message.2 the sender ID
   * @param {String} message.3 the receiver ID
   * @param {String} message.4 the message itself
   * @param {String} message.5 replying to a message
   *
   * Response contains the following:
   * @param {Number} response.bnr the new batch number -- if different, must update in vuex
   * @param {Number} response.d the date of the message in MS
   *
   * @returns {Promise} a promise that resolves to
   *  the sent message datetime in MS if the response was succesful,
   *  or rejects with an error message;
   */
  async sendNewMessage(message, currentUserID) {
    if (message.length !== 5 && message.length !== 6) throw new Error("Invalid message: " + message);

    const response = await socketNSP.emit("MESSAGE:NEW", message);
    if (response.fail) throw new Error("Sending failed: " + response.error);

    const messageData = {
      CID: message[1],
      senderID: message[2],
      message: message[4],
      date: new Date(response.d),
      newestBatchNr: response.bnr, // batchnr
      currentUserID,
      replyingTo: message[5] ? JSON.parse(JSON.stringify(message[5])) : null,
    };
    store.dispatch("messages/addNewMessage", messageData);
    return response.d;
  },

  setMessagesAsSeen() {
    socketNSP.emit("NOTIFS:MSG_SEEN");
    store.commit("indicators/TURN_OFF_INDICATOR", "messenger");
  },

  setConnectionsAsSeen() {
    socketNSP.emit("NOTIFS:CONN_SEEN");
    store.commit("indicators/TURN_OFF_INDICATOR", "connectRequests");
  },

  async setConvoAsRead(conversationID) {
    const response = await socketNSP.emit("MESSAGE:READ", conversationID);
    if (response.success) store.commit("messages/SET_CONVERSATION_AS_READ", conversationID);
    else if (response.fail) throw new Error("Failed to set convo as read.");
  },
};

export default messengerSocket;
